<h2 mat-dialog-title>{{ titulo }} <span class="total-count">({{ localidades.length }})</span></h2>

<mat-dialog-content>
  <div class="table-responsive" style="max-height: 380px; overflow-y: auto;">
    <table class="table table-hover table-sm mb-0">
      <thead class="sticky-top bg-light">
        <tr>
          <th>Localidad</th>
          <th>Provincia</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let l of localidades">
          <td class="font-weight-bold text-dark">{{ l.nombre }}</td>
          <td class="text-muted">{{ l.provincia || '-' }}</td>
        </tr>
        <tr *ngIf="!localidades.length">
          <td colspan="2" class="text-center text-muted py-4">No hay localidades para mostrar.</td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="cerrar()">Cerrar</button>
</mat-dialog-actions>
